// models
import { FieldType } from '@karehero/models';

// components
import { Option } from '@/components/atoms/Select/Select';
import { Validation } from '@/components/organisms/Editor/Editor';

interface Table {
  title: string;
  columns: string[];
  rows: string[];
}

/**
 * createFieldHelper asserts that the field definitions match the type of the
 * form data.
 */
export const createFieldHelper = <T>(fields: {
  [key in keyof T]?: FieldDef;
}) => {
  return fields;
};

/**
 * FieldDef is a definition of a field in a form.
 */
export type FieldDef = {
  id?: string;
  label?: string;
  ariaLabel?: string;
  isRequired?: boolean;
  placeholder?: string;
  description?: string;
  tooltip?: string;
  order?: number;
  validationRules?: Validation[];
  validation?: (value?: string | number | boolean) => boolean;
  isHideTitle?: boolean;
  isDisabled?: boolean;
  field: {
    type: FieldType;
    options?: Option[];
    table?: Table;
    size?: 'sm' | 'md' | 'lg';
    isCustom?: boolean;
    variant?: string;
    maxColumns?: number;
    subfields?: FieldDef[];
    length?: number;
    regex?: RegExp;
    to?: string;
    autoFocus?: boolean;
    limits?: { min?: number; max?: number };
    labels?: { [key: string]: string };
  };
  onInvite?: (careCircleMemberInvite: any) => Promise<any>;
};
